import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const quoteService = {
  getJobQuotes: async (jobId) => {
    const response = await api.get(`/jobs/${jobId}/quotes`);
    return response.data;
  },
  getQuote: async (id) => {
    const response = await api.get(`/quotes/${id}`);
    return response.data;
  },
  createQuote: async (data) => {
    const response = await api.post('/quotes', data);
    return response.data;
  },
  updateQuote: async (id, data) => {
    const response = await api.put(`/quotes/${id}`, data);
    return response.data;
  },
  deleteQuote: async (id) => {
    const response = await api.delete(`/quotes/${id}`);
    return response.data;
  },
};
